import { WorkTimeControlIcon } from 'redesign/components/atoms/Icon'
import { DATE_FORMAT_VARIANTS } from 'redesign/shared/date/constants'
import { formatDateRange } from 'redesign/shared/date/utils'
import { TASK_TYPES } from '../../constants'
import { getContentStatus } from '../../getContentStatus'
import { getDateFormatFromTask } from '../Dates/getDateFormatFromTask'
import { EMPTY_CONTENT_DATA } from '../constants'
import type { GetTaskListData } from '../types'
import { getTaskState } from './getTaskState'
import { isMonthlySheetTask } from './taskDataTypeGuard'

export const getMonthlySheetData = ({ task, locale, t }: GetTaskListData) => {
  const { status, statusFe, taskData, updatedAt } = task

  if (!taskData || !isMonthlySheetTask(taskData)) return EMPTY_CONTENT_DATA

  const dates = {
    startDate: taskData?.startDate ?? '',
    endDate: taskData?.endDate ?? '',
  }

  return {
    bodyText: `${t('monthlySheet.label')} ${formatDateRange({
      dates,
      dateFormat: DATE_FORMAT_VARIANTS.monthOnly,
      locale,
      t,
    })}`,
    startText: t(getTaskState({ statusFe })),
    secondaryText: t(getContentStatus({ status, taskType: TASK_TYPES.monthlySheet })),
    endText: getDateFormatFromTask({ date: updatedAt, locale, t }),
    icon: WorkTimeControlIcon,
  }
}
